import { LOCALES } from 'i18n/locales';

export const contactDetailsIntl = {
    [LOCALES.ENGLISH]: {
        'contactDetails.tableLabel': 'Contact details',
        'contactDetails.records': 'records',
        'contactDetails.property': 'Property',
        'contactDetails.value': 'Value',
        'contactDetails.detail': 'Detail',
        'contactDetails.description': 'Description',
        'contactDetails.email': 'Email',
        'contactDetails.telephone': 'Telephone',
        'contactDetails.department': 'Department',
        'contactDetails.singleLineAddress': 'Address',
        'contactDetails.webForm': 'WebForm',
        'contactDetails.businessContact': 'Business Contact',
        'contactDetails.emergencyContact': 'Emergency Contact',
        'contactDetails.business.contactDetails': 'Business contact details',
        'contactDetails.business.email': 'Business email',
        'contactDetails.business.telephone': 'Business telephone',
        'contactDetails.business.department': 'Business department',
        'contactDetails.business.singleLineAddress': 'Business address',
        'contactDetails.business.webForm': 'Business web form',
        'contactDetails.emergency.contactDetails': 'Emergency contact details',
        'contactDetails.emergency.email': 'Emergency email',
        'contactDetails.emergency.telephone': 'Emergency telephone',
        'contactDetails.emergency.department': 'Emergency department',
        'contactDetails.emergency.singleLineAddress': 'Emergency address',
        'contactDetails.emergency.webForm': 'Emergency web form',
        'contactDetails.multiple': 'See contact details tab below for details'
    },
    [LOCALES.WELSH]: {
        'contactDetails.tableLabel': 'Manylion cyswllt',
        'contactDetails.records': 'cofnodion',
        'contactDetails.property': 'Eiddo',
        'contactDetails.value': 'Gwerth',
        'contactDetails.detail': 'Manylyn',
        'contactDetails.description': 'Disgrifiad',
        'contactDetails.email': 'E-bost',
        'contactDetails.telephone': 'Ffôn',
        'contactDetails.department': 'Adran',
        'contactDetails.singleLineAddress': 'Cyfeiriad',
        'contactDetails.webForm': 'Ffurflen we',
        'contactDetails.businessContact': 'Cyswllt Busnes',
        'contactDetails.emergencyContact': 'Cyswllt Brys',
        'contactDetails.business.contactDetails': 'Manylion cyswllt busnes',
        'contactDetails.business.email': 'E-bost busnes',
        'contactDetails.business.telephone': 'Ffôn busnes',
        'contactDetails.business.department': 'Adran busnes',
        'contactDetails.business.singleLineAddress': 'Cyfeiriad busnes',
        'contactDetails.business.webForm': 'Ffurflen we busnes',
        'contactDetails.emergency.contactDetails': 'Manylion cyswllt mewn argyfwng',
        'contactDetails.emergency.email': 'E-bost mewn argyfwng',
        'contactDetails.emergency.telephone': 'Ffôn mewn argyfwng',
        'contactDetails.emergency.department': 'Adran mewn argyfwng',
        'contactDetails.emergency.singleLineAddress': 'Cyfeiriad mewn argyfwng',
        'contactDetails.emergency.webForm': 'Ffurflen we mewn argyfwng',
        'contactDetails.multiple': '[See contact details tab below for details]'
    }
};
